import React from 'react';
import ReactDOM from 'react-dom';
import {Provider} from 'react-redux';

import './index.scss';
import App from './App';
import * as serviceWorker from './serviceWorker';

import configureStore from './store';
import nosound from 'assets/nosound.mp3';
import {setupAudioUnlock} from 'utils/playSound';

setupAudioUnlock(nosound);

const {store} = configureStore();

ReactDOM.render(
	<Provider store={store}>
		<App />
	</Provider>,
	document.getElementById('root')
);

// If you want your app to work offline and load faster, you can change
// unregister() to register() below. Note this comes with some pitfalls.
// Learn more about service workers: http://bit.ly/CRA-PWA
serviceWorker.unregister();
